import React, { ReactElement, ReactNode } from 'react';
import { NavLink as Link } from 'react-router-dom';

const NavLink: React.FC<{
  className?: string;
  to: string;
  children?: ReactNode;
  onClick?: () => void;
}> = ({ className = '', to, children = null, ...props }): ReactElement => (
  <div className={`flex  ${className}`}>
    <Link to={to} {...props}>
      {children}
    </Link>
  </div>
);

export default NavLink;
